import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './404error.component.html',
  styleUrls: ['./503error.component.css']
})
export class ErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}